// extracted by mini-css-extract-plugin
export default {"commentBox":"CreateIssueForm-module__commentBox--yWrlH"};